export const listCarriers = [
  // {name: 'Mã giao hàng nhanh', key: 'code_ghn'},
  { name: 'Mã GHN', key: 'code_ghnv3' },
  // {name: 'Mã Ninja Van', key: 'code_njv'},
  // {name: 'Mã Kerry', key: 'code_kerry'},
  // {name: 'Mã Speedlink', key: 'code_spl'},
  // {name: 'Mã Ong vàng', key: 'code_ov'},
  // {name: 'Mã SuperShip', key: 'code_supership'},
  // {name: 'Mã hola', key: 'code_hola'},
  // {name: 'Mã snappy', key: 'code_snappy'},
  // {name: 'Mã nhất tín', key: 'code_nhattin'},
  { name: 'Mã SPX', key: 'code_shopee' },
  { name: 'Mã J&T', key: 'code_jnt' },
  { name: 'Mã TikiNow', key: 'code_tikinow' },
  { name: 'Mã VTP', key: 'code_vtp' },
  { name: 'Mã VNP', key: 'code_vnp' },
  { name: 'Mã EMS', key: 'code_ems' },
]



// WEBPACK FOOTER //
// ./src/stubs/carriers.js